import { urlBase } from "./config";
import axiosInstance from "../services/config/axiosinstance";

// GET /status-rsvp/contract/:contractId — lista paginada filtrada por contrato.
// Aceita search em description e filtro enabled. Retorna { data, total }.
// Se contractId não vier, cai na rota global /status-rsvp (usada por outras
// telas que precisam de todos os status ativos, ex: modal de Participantes).
function getStatusRsvp({ contractId, offset, limit, search, enabled }) {
  const params = new URLSearchParams();
  if (offset !== undefined) params.append("offset", offset);
  if (limit !== undefined) params.append("limit", limit);
  if (search) params.append("search", search);
  if (enabled !== undefined) params.append("enabled", enabled);

  const path = contractId
    ? `/status-rsvp/contract/${contractId}`
    : `/status-rsvp`;

  const config = {
    method: "get",
    url: `${urlBase}${path}?${params.toString()}`,
    headers: { "Content-Type": "application/json" },
  };

  return axiosInstance(config)
    .then((response) => response.data)
    .catch((error) => error.response?.data);
}

// POST /status-rsvp — body { description, enabled? }.
function createStatusRsvp(data) {
  const config = {
    method: "post",
    url: `${urlBase}/status-rsvp`,
    headers: { "Content-Type": "application/json" },
    data,
  };

  return axiosInstance(config)
    .then((response) => response)
    .catch((error) => error.response);
}

// PUT /status-rsvp/:id — body parcial { description?, enabled? }.
function editStatusRsvp({ id, data }) {
  const config = {
    method: "put",
    url: `${urlBase}/status-rsvp/${id}`,
    headers: { "Content-Type": "application/json" },
    data,
  };

  return axiosInstance(config)
    .then((response) => response)
    .catch((error) => error.response);
}

export { getStatusRsvp, createStatusRsvp, editStatusRsvp };
